import styled, { css } from 'styled-components';
import { BaSeTheme } from '@base/react';

export const DraggerStyled = styled.div`
  padding: ${({hasImage}) => hasImage ? '24px' : '74px 24px 24px 24px'} ;
  display: flex;
  flex-flow: column;
  align-items: center;
  border: 2px dashed ${BaSeTheme.colors.institucionais.cinzaSebrae90};
  border-radius: 4px;
  gap: 8px;
  margin-top: 4px;
  z-index: 2;
  background-color: ${(props) =>
    props?.drag
      ? BaSeTheme.colors.institucionais.azulSebrae97
      : BaSeTheme.colors.defaultColors.transparent};

  .no-show {
    display: none;
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
`;

export const ImageWrapper = styled.div`
  position: relative;
  height: 200px;
`;

export const ImageContainer = styled.div`
  ${({ image }) => css`
    background-image: url(${image});
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;
    height: 200px;
    width: 100%;
    position: absolute;
    transition: ${BaSeTheme.transitions.allPropertiesContinuousNormal};
  `};
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const RelativeContainer = styled.div`
  position: relative;
`;

export const ImagePositioner = styled.div`
  position: absolute;
  display: flex;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  padding-top: 24px;
  justify-content: center;
  z-index: 1;
`;
